import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06ca996b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "update-time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.isSpider ? (_openBlock(), _createElementBlock("section", _hoisted_1, " 更新时间 " + _toDisplayString(_ctx.updateTime), 1)) : _createCommentVNode("", true);
}